import Point from '../../geom/Point'
import Location from '../Location'
import MathUtils from '../../utils/MathUtils'

function MercatorProjection(referencePoint1, referenceLocation1, referencePoint2, referenceLocation2) {

    var reference1 = { point: referencePoint1, location: referenceLocation1 };
    var reference2 = { point: referencePoint2, location: referenceLocation2 };

    var leftRef = (reference1.location.longitude <= reference2.location.longitude) ? reference1 : reference2;
    var topRef = (reference1.location.latitude <= reference2.location.latitude) ? reference1 : reference2;
    var rightRef = (reference1.location.longitude > reference2.location.longitude) ? reference1 : reference2;
    var bottomRef = (reference1.location.latitude > reference2.location.latitude) ? reference1 : reference2;

    var refPoint1MapPoint = this.locationToWorldPoint(new Location(topRef.location.latitude, leftRef.location.longitude));
    var refPoint2MapPoint = this.locationToWorldPoint(new Location(bottomRef.location.latitude, rightRef.location.longitude));

    var globalXDelta = Math.abs(refPoint1MapPoint.x - refPoint2MapPoint.x);
    var localXDelta = Math.abs(leftRef.point.x - rightRef.point.x);

    var globalYDelta = Math.abs(refPoint1MapPoint.y - refPoint2MapPoint.y);
    var localYDelta = Math.abs(topRef.point.y - bottomRef.point.y);

    this._xScale = localXDelta / globalXDelta;
    this._yScale = localYDelta / globalYDelta;

    var xDeltaFromLeft = leftRef.point.x / this._xScale;
    var yDeltaFromTop = topRef.point.y / this._yScale;

    this._offsetX = refPoint1MapPoint.x - xDeltaFromLeft;
    this._offsetY = refPoint1MapPoint.y - yDeltaFromTop;

    this.reference1 = reference1;
    this.reference2 = reference2;
}

MercatorProjection.MK_MAP_SIZE = 268435456.0;
MercatorProjection.ORIGIN = new Point(MercatorProjection.MK_MAP_SIZE / 2.0, MercatorProjection.MK_MAP_SIZE / 2.0);
MercatorProjection.PIXELS_PER_LONGITUDE_DEGREE = MercatorProjection.MK_MAP_SIZE / 360.0;
MercatorProjection.PIXELS_PER_LONGITUDE_RADIAN = MercatorProjection.MK_MAP_SIZE / (2 * Math.PI);

MercatorProjection.prototype.locationToPoint = function(location) {
    var wPoint = this.locationToWorldPoint(location);
    var xGlobalDelta = wPoint.x - this._offsetX;
    var yGlobalDelta = wPoint.y - this._offsetY;

    var newX = xGlobalDelta * this._xScale;
    var newY = yGlobalDelta * this._yScale;

    return new Point(newX, newY);
};

MercatorProjection.prototype.locationToWorldPoint = function(location) {
    var point = new Point(0, 0);
    point.x = MercatorProjection.ORIGIN.x + location.longitude * MercatorProjection.PIXELS_PER_LONGITUDE_DEGREE;
    var sinY = MathUtils.bound(Math.sin(MathUtils.toRadians(location.latitude)), -0.9999, 0.9999);
    point.y = MercatorProjection.ORIGIN.y + 0.5 * Math.log((1 + sinY) / (1 - sinY)) * -MercatorProjection.PIXELS_PER_LONGITUDE_RADIAN;
    return point;
};

MercatorProjection.prototype.worldPointToLocation = function(worldPoint) {
    var lng = (worldPoint.x - MercatorProjection.ORIGIN.x) / MercatorProjection.PIXELS_PER_LONGITUDE_DEGREE;
    var latRadians = (worldPoint.y - MercatorProjection.ORIGIN.y) / -MercatorProjection.PIXELS_PER_LONGITUDE_RADIAN;
    var lat = MathUtils.toDegrees(2 * Math.atan(Math.exp(latRadians)) - Math.PI / 2);
    return new Location(lat, lng);
};

MercatorProjection.prototype.pointToLocation = function(point) {
    var globalX = (point.x / this._xScale) + this._offsetX;
    var globalY = (point.y / this._yScale) + this._offsetY;
    var coordinate = this.worldPointToLocation(new Point(globalX, globalY));
    return coordinate;
};

export default MercatorProjection;